






























































































import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import PreviewWidget from './widget-setting/PreviewSetting.vue'
import ListWidgetSetting from './widget-setting/TableSetting.vue'

@Component({
  components: {
    ListWidgetSetting,
    PreviewWidget,
  },
  computed: {
    ...mapGetters('settings', {
      canEdit: 'canEdit',
    }),
  },
})
export default class SystemSetting extends Vue {
  canEdit!: () => boolean

  get settings(): any {
    return this.$store.state.settings.item
  }

  get currentUser() {
    return this.$store.state.authentication.currentUser
  }

  get isLoading(): boolean {
    return this.$store.state.settings.loading
  }

  getMessageHideCardAfterMessage(errors) {
    if (errors.has('card_off_after_minutes') && errors.items?.[0]?.rule === 'customGreaterThanZero') {
      return this.$t('messages.field_is_greater_than', { number: 0 })
    } else if (errors.has('card_off_after_minutes')) {
      return this.$t('messages.field_is_required')
    }

    const { minutes, seconds } = this.getTimeOfHideCardInput()
    return this.$t('messages.card_off_after_minutes_desc', { minutes, seconds })
  }

  getTimeOfHideCardInput() {
    const cardOffAfterMinutes = parseFloat(this.settings.card_off_after_minutes)
    const minutes = Math.floor(cardOffAfterMinutes)
    const seconds = Math.round((cardOffAfterMinutes - minutes) * 60)
    return { minutes, seconds }
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }

      this.$store.dispatch('settings/update', this.settings).then((resp) => {
        this.$buefy.toast.open(this.$t('messages.update_success') as string)
      })
    })
  }

  // After page created
  async created() {
    await this.$store.dispatch('settings/get')
    await this.$store.dispatch('settings/getWidgetPersonalSettings')

    // Customize rule of vee-validator
    this.$validator.extend('customGreaterThanZero', (value) => {
      if (value <= 0) {
        return false
      }

      const { minutes, seconds } = this.getTimeOfHideCardInput()
      if (minutes === 0 && seconds === 0) {
        return false
      }

      return true
    })
  }

  beforeDestroy() {
    this.$store.commit('settings/RESET_WIDGET')
  }
}
